import AutocompleteInput from '../inputs/AutocompleteInput';
import createField from './createField';

const AutocompleteField = createField(AutocompleteInput, {
  commitWarningOnChange: true,
});

export default AutocompleteField;
